// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"navGroup_root__j8A85","navList":"navGroup_navList__G2BR3"};